
import { defineComponent, ref } from "vue";
import store from "@/store/index";
import Utils from "@/components/Utils";

export default defineComponent({
  computed: {
    readyNotice() {
      return store.state.readyNotice;
    },
  },

  watch: {
    async readyNotice(value) {
      if (!value) return;

      const data = await Utils.getNotice();
      this.messages = data.messages;
      this.showWindow = data.show;

      if (data.show) {
        const unityInstance = store.state.unityInstance;
        unityInstance.SendMessage("[GameManager]", "DisablePlayerController");
      }
    },
  },

  setup() {
    const showWindow = ref<boolean>(false);

    const messages = ref<string[]>([]);

    const closeWindow = () => {
      showWindow.value = false;
      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "ClosePresentWindow");
      unityInstance.SendMessage("[GameManager]", "EnablePlayerController");
    };

    return {
      messages,
      showWindow,
      closeWindow,
    };
  },
});
